import { sanitize } from "dompurify";

const QuestionDescription = ({ description }) => {
  const sanitizedDescription = sanitize(description);

  return (
    <h5
      className="card-text"
      style={{ whiteSpace: "pre-line" }}
      dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
    ></h5>
  );
};

export default QuestionDescription;
